import * as React from "react";

export const wrapPrimitive = (child: React.ReactChild) => (typeof child === "object" ? child : <>{child}</>);
